var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarrierAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5V4C7 3.44772 6.55228 3 6 3H5C4.44772 3 4 3.44772 4 4V4.5H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5H4V20C4 20.5523 4.44772 21 5 21H6C6.55228 21 7 20.5523 7 20V14.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5H20V20C20 20.5523 19.5523 21 19 21H18C17.4477 21 17 20.5523 17 20V14.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.5V4C20 3.44772 19.5523 3 19 3H18C17.4477 3 17 3.44772 17 4V4.5H20Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43934 6H2.94281C2.42211 6 2 6.4159 2 6.92894V12.0711C2 12.181 2.01938 12.2865 2.05497 12.3844L8.43934 6Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56067 13H7.43935L14.4393 6H10.5607L3.56067 13Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5607 6L9.56067 13H13.4393L20.4393 6H16.5607Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.945 6.6156L15.5607 13H21.0572C21.5779 13 22 12.5841 22 12.0711V6.92891C22 6.81897 21.9806 6.71349 21.945 6.6156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrierAlt);
export default __webpack_public_path__ + "static/media/barrier-alt.f1f7b61294b8f85798e844c92a5a225b.svg";
export { ForwardRef as ReactComponent };